import React from 'react';
import BaseField, {
	BaseFieldProps,
} from '../../../Base/Components/Inputs/BaseField/BaseField';
import QuestionnaireMultiSelectWithCheckList from './QuestionnaireMultiSelectWithCheckList';

interface Props extends BaseFieldProps {
	isSearchable?: boolean;
	portal?: boolean;
}

const ECardFolderSelectField: React.FC<Props> = props => (
	<BaseField {...props}>
		<QuestionnaireMultiSelectWithCheckList
			portal={props.portal}
			isSearchable={props.isSearchable}
		/>
	</BaseField>
);

export default ECardFolderSelectField;
